<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">参保信息（国民健康保险工团(NHIS)）</h3>
            <p class="depth">
                参保人必须携带地区医生的诊疗委托书,在医院窗口提交才能受保险优惠. <br>
                否则首先需要得看家庭医学科医生. <br>
                委托书仅限于有医学见解的诊疗科有效,想要在其他诊疗科看诊时,应携带记载该诊疗科意见的诊疗委托书.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">个人保险者信息</h3>
            <p class="depth">参民保的患者必须预付医疗费用,然后向保险公司提交账单.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>